<!-- Bloqueo de chat premium -->
<ion-card class="premium-chat-lock-card" color="light">
  <ion-card-content class="flex flex-col items-center text-center justify-center gap-4">
    <!-- Icono de bloqueo -->
    <div class="lock-icon-wrapper">
      <ion-icon name="lock-closed" color="primary" class="lock-icon"></ion-icon>
    </div>

    <h3 class="lock-title">
      {{ t.getItemTranslated('PREMIUM_CHAT.TITLE') || 'Chat Premium' }}
    </h3>

    <!-- Vista del propietario del objeto (debe pagar) -->
    <ng-container *ngIf="isObjectOwner">
      <p class="lock-description">
        {{ t.getItemTranslated('PREMIUM_CHAT.DESCRIPTION_OWNER') || 'Unlock premium chat to communicate with the finder and access the verification code system.' }}
      </p>

      <div class="amount-display">
        <span class="amount-label">
          {{ t.getItemTranslated('PREMIUM_CHAT.AMOUNT_LABEL') || 'Amount' }}:
        </span>
        <span class="amount-value">{{ premiumChatAmount | number:'1.2-2' }} €</span>
      </div>

      <!-- Mensaje gratuito del propietario (si ya fue enviado) -->
      <div *ngIf="ownerFreeMessage" class="owner-free-msg mt-2 w-full">
        <ion-label class="text-xs text-[var(--ion-color-medium)] font-semibold">
          {{ t.getItemTranslated('PREMIUM_CHAT.OWNER_FREE_MSG_LABEL') || 'Your message for the finder' }}:
        </ion-label>
        <ion-card color="light" class="mt-1 mb-0">
          <ion-card-content class="py-2 px-3 text-sm italic">
            {{ ownerFreeMessage }}
          </ion-card-content>
        </ion-card>
      </div>

      <ion-button expand="block" color="primary" (click)="requestPay()" [disabled]="loading" class="pay-button">
        <ion-spinner *ngIf="loading" name="crescent" slot="start"></ion-spinner>
        <ion-icon *ngIf="!loading" name="card" slot="start"></ion-icon>
        {{ t.getItemTranslated('PREMIUM_CHAT.PAY_BUTTON') || 'Unlock Premium Chat' }}
      </ion-button>

      <ion-button expand="block" fill="outline" color="medium" (click)="directClose.emit()" [disabled]="loading" class="pay-button">
        <ion-icon name="checkmark-done" slot="start"></ion-icon>
        {{ t.getItemTranslated('PREMIUM_CHAT.DIRECT_CLOSE_BUTTON') || 'Mark as delivered (skip payment)' }}
      </ion-button>
    </ng-container>

    <!-- Vista del finder (espera a que el propietario pague) -->
    <ng-container *ngIf="!isObjectOwner">
      <p class="lock-description">
        {{ t.getItemTranslated('PREMIUM_CHAT.DESCRIPTION_FINDER') || 'The object owner must unlock premium chat before you can continue the conversation.' }}
      </p>

      <ion-chip color="warning" class="waiting-chip">
        <ion-icon name="time"></ion-icon>
        <ion-label>
          {{ t.getItemTranslated('PREMIUM_CHAT.WAITING_FOR_PAYMENT') || 'Waiting for payment' }}
        </ion-label>
      </ion-chip>

      <!-- Mensaje del propietario (si ya fue enviado) -->
      <div *ngIf="ownerFreeMessage" class="owner-free-msg mt-3 w-full">
        <ion-label class="text-xs text-[var(--ion-color-medium)] font-semibold">
          {{ t.getItemTranslated('PREMIUM_CHAT.FINDER_MSG_FROM_OWNER') || 'Message from the owner' }}:
        </ion-label>
        <ion-card color="light" class="mt-1 mb-0">
          <ion-card-content class="py-2 px-3 text-sm italic">
            {{ ownerFreeMessage }}
          </ion-card-content>
        </ion-card>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>

<!-- Premium chat payment confirmation modal -->
<app-dialog [show]="showPaymentConfirm" [close]="true" (toggle)="cancelPaymentConfirm()">
  <div class="flex flex-col gap-3 p-2 text-left">
    <h3 class="text-lg font-semibold text-center">{{ 'PREMIUM_CHAT_CONFIRM.TITLE' | translate }}</h3>
    <p class="text-[13px] leading-snug" [innerHTML]="'PREMIUM_CHAT_CONFIRM.BODY_1' | translate"></p>
    <p class="text-[13px] leading-snug">{{ 'PREMIUM_CHAT_CONFIRM.BODY_2' | translate }}</p>
    <p class="text-[13px] leading-snug" [innerHTML]="('PREMIUM_CHAT_CONFIRM.BODY_3' | translate:{ amount: premiumChatAmount })"></p>
    <p class="text-[13px] leading-snug" [innerHTML]="'PREMIUM_CHAT_CONFIRM.BODY_4' | translate"></p>
    <div class="public-profile-share-callout">
      <img
        src="../../../assets/svg/public-profile-share.svg"
        alt=""
        aria-hidden="true"
        class="public-profile-share-callout__icon"
      />
      <p class="public-profile-share-callout__text">
        {{ 'PUBLIC_PROFILE_SHARE_DIALOG.PREMIUM_CHAT_OWNER_NOTICE' | translate }}
        {{ 'PUBLIC_PROFILE_SHARE_DIALOG.REVIEW_SETTINGS_PREFIX' | translate }}
        <a href="#" class="font-semibold underline" (click)="openPublicProfileSettings($event)">
          {{ 'PUBLIC_PROFILE_SHARE_DIALOG.SETTINGS_LINK' | translate }}
        </a>.
      </p>
    </div>
    <label class="flex items-start gap-2 mt-2 cursor-pointer">
      <input type="checkbox" [(ngModel)]="termsAccepted" class="mt-1" />
      <span class="text-[12px] leading-snug terms-label" (click)="openTerms($event)" [innerHTML]="'PREMIUM_CHAT_CONFIRM.CHECKBOX_LABEL' | translate"></span>
    </label>
    <ion-button expand="block" color="primary" [disabled]="!termsAccepted || loading" (click)="confirmPay()" class="mt-2">
      {{ 'PREMIUM_CHAT_CONFIRM.PAY_BUTTON' | translate }}
    </ion-button>
    <p class="text-[11px] text-center text-gray-400">{{ 'PREMIUM_CHAT_CONFIRM.FOOTER' | translate }}</p>
  </div>
</app-dialog>